import { render } from "./cartBtn.vue?vue&type=template&id=42845988&scoped=true&ts=true"
import script from "./cartBtn.vue?vue&type=script&lang=ts"
export * from "./cartBtn.vue?vue&type=script&lang=ts"

import "./cartBtn.vue?vue&type=style&index=0&id=42845988&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42845988"],['__file',"src/components/cartBtn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "42845988"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('42845988', __exports__)) {
    api.reload('42845988', __exports__)
  }
  
  module.hot.accept("./cartBtn.vue?vue&type=template&id=42845988&scoped=true&ts=true", () => {
    api.rerender('42845988', render)
  })

}


export default __exports__